/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Chip, CircularProgress, debounce } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { isUserLoggedIn } from "utils";
import { getSearchResults } from "utils/apiClients";
import { useWindowResize } from "utils/hooks";
import { getSearchEventProps, setSearchEventProps } from "utils/commonUtils";
import { SEARCH_MP_EVENTS_PROPS_NAME } from "modules/candidate/profile/constants/mixpanelConstants";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import { VALUE_TO_LABEL_MAPPING } from "components/RevampFeedDetails/constants";
import HistoryIconNew from "assets/svgs/HistoryIcon";
import HistoryIcon from "@material-ui/icons/History";
import HighlightQuery from "./HighlightQuery";

function QuerySearchResults({
	handleQuerySelect,
	handleExperienceSelect,
	handleCitySelect,
	query = "",
	recentSearches,
	handleSearchFeatureUsed,
}) {
	const [filteredResults, setFilteredResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const [isMobileView] = useWindowResize();
	const searchResults = (queryString: string) => {
		setLoading(true);
		return getSearchResults(queryString)
			.then((resp: any) => {
				setLoading(false);
				setFilteredResults(resp?.data?.suggestions?.slice(0, 5) || []);
			})
			.catch((e) => {
				console.log(e);
				setLoading(false);
				setFilteredResults([]);
			});
	};
	const debouncedSearch = useRef(debounce(searchResults, 250));
	useEffect(() => {
		if (query?.trim()?.length > 1) {
			debouncedSearch?.current(query);
		}
	}, [query]);

	const renderRecentPopularSearchLabel = (searchObj) => {
		if (
			searchObj?.prefill_ui_config?.keyword &&
			searchObj?.prefill_ui_config?.location &&
			searchObj?.prefill_ui_config?.experience
		)
			return `${searchObj?.prefill_ui_config?.keyword}, ${searchObj?.prefill_ui_config?.experience}, ${searchObj?.prefill_ui_config?.location}`;
		if (
			searchObj?.prefill_ui_config?.keyword &&
			searchObj?.prefill_ui_config?.location
		)
			return `${searchObj?.prefill_ui_config?.keyword}, ${searchObj?.prefill_ui_config?.location}`;
		if (
			searchObj?.prefill_ui_config?.keyword &&
			searchObj?.prefill_ui_config?.experience
		)
			return `${searchObj?.prefill_ui_config?.keyword}, ${searchObj?.prefill_ui_config?.experience}`;
		if (searchObj?.prefill_ui_config?.keyword)
			return `${searchObj?.prefill_ui_config?.keyword}`;
	};

	useEffect(() => {
		// if (popularSearches?.length > 0) {
		// 	trackOnMixpanel("Popular Search Widget Shown Web", {
		// 		"Popular Search List": popularSearches?.map(
		// 			(search) => search?.display_name
		// 		),
		// 		Screen: "Search Landing",
		// 		"Popular Search Entity Type List": popularSearches?.map(
		// 			(search) => search?.type || null
		// 		),
		// 	});
		// }
		if (recentSearches?.length > 0)
			trackOnMixpanel("Recent Search Widget Shown Web", {
				"Recent Search List": recentSearches?.map(
					(search) => search?.display_name
				),
				Screen: "Search Landing",
				"Recent Search Entity Type List": recentSearches?.map(
					(search) => search?.type || null
				),
			});
	}, [recentSearches]);
	if (query?.trim().length) {
		let content: any = filteredResults.map((search: any) => (
			<div
				key={search.id}
				className="flex w-full cursor-pointer flex-row items-center gap-2 px-4 py-[6px] hover:bg-[#EAF8F4]"
				onMouseDown={() => {
					const searchEventObj = getSearchEventProps();
					const obj = {
						[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]: "Suggested",
					};
					const resObj = { ...searchEventObj, ...obj };
					setSearchEventProps(resObj);
					handleSearchFeatureUsed("Suggested");
					handleQuerySelect(search);
				}}
				onClick={() => {
					const searchEventObj = getSearchEventProps();
					const obj = {
						[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]: "Suggested",
					};
					const resObj = { ...searchEventObj, ...obj };
					setSearchEventProps(resObj);
					handleSearchFeatureUsed("Suggested");
					handleQuerySelect(search);
				}}
				data-testid="search-keyword-suggestions"
			>
				<div className="flex h-[45px] min-w-[45px] items-center justify-center rounded-md bg-[#F4F2F6] p-1">
					<Search color="disabled" />
				</div>
				<div className="w-full overflow-hidden text-ellipsis whitespace-nowrap text-[#8C8594]">
					<div className="overflow-hidden text-ellipsis text-[16px]">
						<HighlightQuery text={search.display_name} query={query} />
					</div>
					<div className="text-[14px]">{search.display_type}</div>
				</div>
			</div>
		));

		if (loading) {
			content = <CircularProgress />;
		}
		// Fuzzy search option
		if (!loading && !filteredResults.length) {
			return (
				<div
					id="js-navigation-parent"
					className="flex w-full flex-col items-start"
				>
					<div
						className="flex w-full cursor-pointer flex-row items-center gap-2 px-4 py-[6px] hover:bg-[#EAF8F4]"
						onMouseDown={() => {
							const searchEventObj = getSearchEventProps();
							const obj = {
								[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
									"Fuzzy",
							};
							const resObj = { ...searchEventObj, ...obj };
							setSearchEventProps(resObj);
							handleSearchFeatureUsed("Fuzzy");
							handleQuerySelect({ display_name: query });
						}}
						onClick={() => {
							const searchEventObj = getSearchEventProps();
							const obj = {
								[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
									"Fuzzy",
							};
							const resObj = { ...searchEventObj, ...obj };
							setSearchEventProps(resObj);
							handleSearchFeatureUsed("Fuzzy");
							handleQuerySelect({ display_name: query });
						}}
					>
						<div className="flex h-[45px] w-[45px] items-center justify-center rounded-md bg-[#F4F2F6] p-1">
							<Search color="disabled" />
						</div>
						<div className="w-100 overflow-hidden text-ellipsis whitespace-nowrap text-[14px]">
							{query}
						</div>
					</div>
				</div>
			);
		}

		return (
			<div className="flex w-full flex-col gap-3 py-2 md:py-0">
				<div
					id="js-navigation-parent"
					className={`flex flex-col ${
						loading ? "items-center" : "items-start"
					}`}
				>
					{content}
				</div>
			</div>
		);
	}
	return (
		<div className="flex max-h-[500px] w-full flex-col gap-[24px] overflow-scroll py-2 md:py-0">
			{isUserLoggedIn() &&
				Array.isArray(recentSearches) &&
				recentSearches?.length > 0 && (
					<div className="flex flex-col space-y-[12px]">
						<p className="m-0 px-[16px] text-sm font-semibold leading-[20px]">
							Recent searches
						</p>
						<div className="flex flex-row flex-wrap space-y-[12px] px-[16px] md:hidden">
							{recentSearches.map((searchOption: any) => {
								if (searchOption?.prefill_ui_config?.keyword)
									return (
										<div
											className="flex w-full space-x-[12px]"
											key={searchOption?.prefill_ui_config?.keyword}
											onMouseDown={() => {
												const searchEventObj =
													getSearchEventProps();
												const obj = {
													[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
														"Recent",
												};
												const resObj = {
													...searchEventObj,
													...obj,
												};
												setSearchEventProps(resObj);
												handleSearchFeatureUsed("Recent");
												// handlePopularSearchSelect(searchOption);
												trackOnMixpanel(
													"Recent Search Item Clicked Web",
													{
														Screen: "Search Landing",
														"Entity Type": searchOption?.type,
														"Search Query":
															searchOption?.name,
													}
												);
												handleQuerySelect({
													display_name: searchOption?.name,
													display_type: searchOption?.type,
													id: searchOption?.id,
													type: searchOption?.type,
												});
												handleExperienceSelect({
													display_text:
														VALUE_TO_LABEL_MAPPING
															?.min_experience?.[
															searchOption?.experience_input
														],
													experience_input:
														searchOption?.experience_input,
												});
												if (searchOption?.location?.name) {
													handleCitySelect(
														searchOption?.location
													);
													return;
												}

												if (searchOption?.location?.name) {
													handleCitySelect(
														searchOption?.location
													);
													return;
												}
												if (searchOption?.city?.name) {
													handleCitySelect(searchOption?.city);
												}
											}}
											onClick={() => {
												handleQuerySelect({
													display_name: searchOption?.name,
													display_type: searchOption?.type,
													id: searchOption?.id,
													type: searchOption?.type,
												});
												handleExperienceSelect({
													display_text:
														VALUE_TO_LABEL_MAPPING
															?.min_experience?.[
															searchOption?.experience_input
														],
													experience_input:
														searchOption?.experience_input,
												});

												if (searchOption?.location?.name) {
													handleCitySelect(
														searchOption?.location
													);
													return;
												}
												if (searchOption?.city?.name) {
													handleCitySelect(searchOption?.city);
												}
											}}
										>
											<div className="">
												<HistoryIconNew
													iconBackground={
														!isMobileView ? "#fff" : "#F4F2F6"
													}
												/>
											</div>
											<div className="flex-1">
												<p className="m-0 truncate text-[14px] leading-[20px] text-[#190A28]">
													{
														searchOption?.prefill_ui_config
															?.keyword
													}
													{searchOption?.prefill_ui_config
														?.experience
														? `, ${searchOption?.prefill_ui_config?.experience}`
														: ""}
												</p>
												<p className="m-0 text-[12px] leading-[16px]">
													{
														searchOption?.prefill_ui_config
															?.location
													}
												</p>
											</div>
										</div>
									);
								return <></>;
							})}
						</div>
						<div className="hidden flex-row flex-wrap space-x-[4px] space-y-[12px] px-[16px] md:flex">
							{recentSearches.map((searchOption: any) => {
								if (searchOption?.prefill_ui_config?.keyword)
									return (
										<div className="w-full" key={searchOption.id}>
											<Chip
												icon={<HistoryIcon fontSize="small" />}
												onMouseDown={() => {
													const searchEventObj =
														getSearchEventProps();
													const obj = {
														[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
															"Recent",
													};
													const resObj = {
														...searchEventObj,
														...obj,
													};
													setSearchEventProps(resObj);
													handleSearchFeatureUsed("Recent");
													// handlePopularSearchSelect(searchOption);
													trackOnMixpanel(
														"Recent Search Item Clicked Web",
														{
															Screen: "Search Landing",
															"Entity Type":
																searchOption?.type,
															"Search Query":
																searchOption?.name,
														}
													);
													handleQuerySelect({
														display_name: searchOption?.name,
														display_type: searchOption?.type,
														id: searchOption?.id,
														type: searchOption?.type,
													});
													handleExperienceSelect({
														display_text:
															VALUE_TO_LABEL_MAPPING
																?.min_experience?.[
																searchOption
																	?.experience_input
															],
														experience_input:
															searchOption?.experience_input,
													});

													if (searchOption?.location?.name) {
														handleCitySelect(
															searchOption?.location
														);
														return;
													}
													if (searchOption?.city?.name) {
														handleCitySelect(
															searchOption?.city
														);
													}
												}}
												onClick={() => {
													handleQuerySelect({
														display_name: searchOption?.name,
														display_type: searchOption?.type,
														id: searchOption?.id,
														type: searchOption?.type,
													});
													handleExperienceSelect({
														display_text:
															VALUE_TO_LABEL_MAPPING
																?.min_experience?.[
																searchOption
																	?.experience_input
															],
														experience_input:
															searchOption?.experience_input,
													});

													if (searchOption?.location?.name) {
														handleCitySelect(
															searchOption?.location
														);
														return;
													}
													if (searchOption?.city?.name) {
														handleCitySelect(
															searchOption?.city
														);
													}
												}}
												label={renderRecentPopularSearchLabel(
													searchOption
												)}
												variant="outlined"
												className="max-w-[350px] text-wrap"
											/>
										</div>
									);
								return <></>;
							})}
						</div>
					</div>
				)}
			{/* {popularSearches?.length > 0 && (
				<div className="flex flex-col gap-2">
					<div className="flex flex-col px-4 ">
						<p className="m-0 text-sm font-semibold leading-[20px]">
							Popular searches
						</p>
						{isUserLoggedIn() && (
							<p className=" m-0 text-[12px] font-[400] text-[#8C8594]">
								Trending among job seekers like you
							</p>
						)}
					</div>

					<div className="flex flex-row flex-wrap gap-[8px] px-4">
						{popularSearches.map((searchOption: any) => (
							<Chip
								key={searchOption.id}
								onMouseDown={() => {
									const searchEventObj = getSearchEventProps();
									const obj = {
										[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
											"Popular",
									};
									const resObj = { ...searchEventObj, ...obj };
									setSearchEventProps(resObj);
									handleSearchFeatureUsed("Popular");
									handlePopularSearchSelect(searchOption);
									trackOnMixpanel("Popular Search Item Clicked Web", {
										Screen: "Search Landing",
										"Entity Type": searchOption?.type,
										"Search Query": searchOption?.display_name,
									});
									handleQuerySelect({
										display_name: searchOption?.name,
										display_type: searchOption?.type,
										id: searchOption?.id,
										type: searchOption?.type,
									});
									handleExperienceSelect({
										display_text:
											VALUE_TO_LABEL_MAPPING?.min_experience?.[
												searchOption?.experience_input
											],
										experience_input: searchOption?.experience_input,
									});
									handleCitySelect(searchOption?.location);
								}}
								onClick={() => {
									handleQuerySelect({
										display_name: searchOption?.name,
										display_type: searchOption?.type,
										id: searchOption?.id,
										type: searchOption?.type,
									});
									handleExperienceSelect({
										display_text:
											VALUE_TO_LABEL_MAPPING?.min_experience?.[
												searchOption?.experience_input
											],
										experience_input: searchOption?.experience_input,
									});
									handleCitySelect(searchOption?.location);
								}}
								label={renderRecentPopularSearchLabel(searchOption)}
								variant="outlined"
								className="max-w-[350px] text-wrap"
							/>
						))}
					</div>
				</div>
			)} */}
		</div>
	);
}

export default QuerySearchResults;
